import token, { tokenToVars } from '../token';
import Tooltip from './tooltip';

export { Tooltip };
export default tokenToVars(Tooltip, token);
